var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18h.01m13.58 6.41l-7.17 7.17a1.998 1.998 0 01-2.83 0L12.5 23V13h10l8.59 8.59a2 2 0 010 2.82z",
    stroke: "#476FF2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHk9IjAuNSIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiByeD0iMjIiIGZpbGw9IiNFREYxRkYiIC8+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0xNy41IDE4SDE3LjUxTTMxLjA5IDI0LjQxTDIzLjkyIDMxLjU4QzIzLjczNDMgMzEuNzY2IDIzLjUxMzcgMzEuOTEzNSAyMy4yNzA5IDMyLjAxNDFDMjMuMDI4MSAzMi4xMTQ4IDIyLjc2NzggMzIuMTY2NiAyMi41MDUgMzIuMTY2NkMyMi4yNDIyIDMyLjE2NjYgMjEuOTgxOSAzMi4xMTQ4IDIxLjczOTEgMzIuMDE0MUMyMS40OTYzIDMxLjkxMzUgMjEuMjc1NyAzMS43NjYgMjEuMDkgMzEuNThMMTIuNSAyM1YxM0gyMi41TDMxLjA5IDIxLjU5QzMxLjQ2MjUgMjEuOTY0NyAzMS42NzE2IDIyLjQ3MTYgMzEuNjcxNiAyM0MzMS42NzE2IDIzLjUyODQgMzEuNDYyNSAyNC4wMzUzIDMxLjA5IDI0LjQxWiIKICAgICAgICBzdHJva2U9IiM0NzZGRjIiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";
export { SvgProjectType as ReactComponent };